var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.noData
      ? _c("div", [_vm._m(1)])
      : _c("div", { staticClass: "py-4 lg:py-8" }, [
          _vm.loading
            ? _c("div", { staticClass: "flex justify-center items-center" }, [
                _c("div", { staticClass: "donut multi" })
              ])
            : _c("div", { staticClass: "programmeCards flex flex-wrap" }, [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "div",
                    { staticClass: "-mx-4 flex flex-wrap justify-start" },
                    _vm._l(_vm.data, function(d, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "vue-card px-4 w-full sm:w-1/2 lg:w-1/3 mb-4 sm:mb-8",
                          attrs: { "data-id": d.postid }
                        },
                        [
                          _c("event-card", {
                            attrs: { data: d, page: "favoriten" }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ])
              ])
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex justify-center pb-20" }, [
      !_vm.loadMoreClicked && _vm.navigation && !_vm.loading && !_vm.noData
        ? _c("div", { staticClass: "flex items-center" }, [
            _c(
              "button",
              {
                staticClass:
                  "button bg-blue cursor-pointer bg-blueDark text-white",
                on: {
                  click: function($event) {
                    return _vm.loadMore()
                  }
                }
              },
              [_vm._v("\n        Toon meer\n      ")]
            )
          ])
        : _vm.loadMoreClicked && _vm.navigation
        ? _c("div", { staticClass: "flex justify-center items-center" }, [
            _c("div", { staticClass: "donut multi" })
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container cards-filter-buttons" }, [
      _c(
        "div",
        {
          staticClass:
            "mb-4 lg:relative lg:flex lg:justify-between lg:items-end"
        },
        [
          _c("div", { staticClass: "header-left w-full lg:w-auto" }, [
            _c(
              "h1",
              {
                staticClass:
                  "heading font-whd text-gulfBlue text-50px md:text-70px lg:text-90px sm:mb-2 md:mb-4 lg:mb-6"
              },
              [_vm._v("\n          Favorieten\n        ")]
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "py-32 text-center" }, [
        _vm._v(
          "\n        Geen evenementen gevonden. Probeer het alstublieft opnieuw.\n      "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/johntanyuehan/Workspace/devilbox/data/www/whd/htdocs/wp-content/themes/wereldhavendagen/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/johntanyuehan/Workspace/devilbox/data/www/whd/htdocs/wp-content/themes/wereldhavendagen/node_modules/vue-loader/lib?{}!./scripts/vue/FavouritenComponent.vue?vue&type=template&id=2e9d4894&
// module id = 106
// module chunks = 0